import { Badge, Box, Text } from '@mantine/core';

export function WorkflowProperty({ text }: { text: string }) {
  if (text === 'On') {
    return (
      <Box>
        <Badge color='cyan.0' p='xs' c='black' radius='md'>
          On
        </Badge>
      </Box>
    );
  }
  if (text === 'Off') {
    return (
      <Box>
        <Badge color='red.0' p='xs' c='black' radius='md'>
          Off
        </Badge>
      </Box>
    );
  }

  return (
    <Text size='sm' c='dark.9'>
      {text}
    </Text>
  );
}
